import { createFileRoute } from '@tanstack/react-router'
import { Route as RouteIcon } from 'lucide-react'
import { lazy, Suspense } from 'react'

// The journey page loads in its own chunk with its messages, so the initial JS does not grow
// (spec 019).
const JourneyPage = lazy(() => import('../components/journey/JourneyPage.js'))

export const Route = createFileRoute('/journey')({
  component: () => (
    <Suspense fallback={null}>
      <JourneyPage emptyIcon={<RouteIcon size={32} />} />
    </Suspense>
  ),
})
